import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

/** Encapsulates media upload + scenario submission so the page component only
 * has to handle rendering and form state. */
export function useScenarioSubmit() {
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const submitScenario = async ({ title, content, category, mediaFile }) => {
    setError("");
    if (!category) {
      setError("Please choose a category");
      return false;
    }
    setLoading(true);
    try {
      let media_path = null;
      let media_type = null;
      let format = "text";
      if (mediaFile) {
        setUploading(true);
        const formData = new FormData();
        formData.append("file", mediaFile);
        const { data } = await api.post("/uploads", formData, { headers: { "Content-Type": "multipart/form-data" } });
        media_path = data.storage_path;
        media_type = data.media_type;
        format = "video";
        setUploading(false);
      }
      await api.post("/scenarios", { title, content, category, format, media_path, media_type });
      setSubmitted(true);
      return true;
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
      return false;
    } finally {
      setLoading(false);
    }
  };

  const getSubmitLabel = () => {
    if (uploading) return "Uploading media...";
    if (loading) return "Submitting...";
    return "Submit to the Voting Feed";
  };

  return { submitScenario, loading, error, submitted, submitLabel: getSubmitLabel() };
}
